module.exports = __webpack_public_path__ + "static/r16-ddd774a9c01c878f67dff31b88f1f611.jpg";